/* eslint-disable eqeqeq */
import { handleTabToNext } from '../../formKit';
import { ACCESSORY_FORM_CONFIGS } from '../accessoryFormConfigs';
import { useAccessoryForm } from '../useAccessoryForm';
import { AccessoryHeading, AccSubtab, APSelect, ASelect } from '../accessoryFieldKit';
import MountingSection from '../MountingSection';
import AccessoryMountingPopup, {
  CasingMountSpecialParameters,
} from '../AccessoryMountingPopup';
import { CasingMountRow } from './LouverForm';
import type { AccessoryFormProps } from '../AccessoryFormHost';

/**
 * Phase 6e2b-1 — DISCONNECT form (accessories/disconnect/{form.js 90,
 * form.tmpl 344}, read in full). Plain clone: master_disconnect_id ←
 * disconnect_params; properties (mfg/series/model/NEMA select/amp rating/
 * wiring) + mounting (clone variant).
 */
const config = ACCESSORY_FORM_CONFIGS.disconnect;

const DisconnectForm = ({ row, section, tunnel, expanded }: AccessoryFormProps) => {
  const api = useAccessoryForm({
    config,
    row,
    section,
    tunnel,
    expanded,
    labeledSubtabs: ['mounting'],
  });
  const { model } = api;
  if (api.loading || !model) {
    return <div className="preloader dotted-preloader active" />;
  }
  const cid = row.id;

  return (
    <>
      <AccessoryHeading api={api} target="master_disconnect_id" visClass="vis-disconnect" />
      <form ref={(el) => { api.formRef.current = el; }} onKeyDown={handleTabToNext}>
        <ul className="inputs-group sublist">
          <AccSubtab api={api} type="disconnect" cid={cid} name="properties" sublistClass="max-height-auto">
            <APSelect api={api} target="master_disconnect_id" name="mfg_id" label="Manufacturer" required cmsPath="manufacturer" />
            <APSelect api={api} target="master_disconnect_id" name="series_id" label="Series" required cmsPath="series" labelKey="series" />
            <APSelect api={api} target="master_disconnect_id" name="model" label="Model" required cmsPath="model" labelKey="model" valueKey="model" />
            {/* noneMode="visible", NOT hideNone={false}: form.tmpl:55/68/82 give
                these three selects a BARE `<option value="None">- -</option>`,
                unlike mfg/series/model on :19/:31/:43 which carry class="hide" —
                so legacy lets you pick `- -` back and clear the field.
                `hideNone={false}` reads as "don't hide it" but resolves to
                noneMode 'hidden' (formKit.tsx:220 — the old boolean only ever
                chose between 'omit' and 'hidden'), which stamps class="hide" and
                Bootstrap's `.hide {display:none}` drops the option out of the
                list entirely. */}
            <APSelect api={api} target="master_disconnect_id" name="nema_encl_type_id" label="NEMA Type" cmsPath="nema_encl_type" noneMode="visible" />
            <APSelect
              api={api}
              target="master_disconnect_id"
              name="amp_rating"
              label="Rating"
              unit="Amp"
              cmsPath="amp_rating"
              labelKey="amp_rating"
              valueKey="amp_rating"
              rowClass="long-line"
              noneMode="visible"
            />
            <ASelect api={api} name="wiring_id" label="Wiring" cmsPath="wiring" noneMode="visible" />
          </AccSubtab>

          <MountingSection
            api={api}
            type="disconnect"
            cid={cid}
            variant="clone"
            sublistDisabled={model.get('master_disconnect_id') === null}
          >
            {/* inline casing_mount radio row (disconnect tmpl — 6e2b verifier). */}
            <CasingMountRow api={api} />
          </MountingSection>
        </ul>
      </form>
      <div id={`popup_accessory_mounting_${row.id}`} className="popup-wrapper location-popup">
        <div className="popup-content popup-content-animation" />
      </div>
      <AccessoryMountingPopup
        api={api}
        typeName="disconnect"
        typeValue="disconnect"
        SpecialParameters={CasingMountSpecialParameters}
      />
    </>
  );
};

export default DisconnectForm;
